// Display helpers for the authenticated Supabase user.
export const displayName = (user) => {
  if (!user) return "";
  const meta = user.user_metadata || {};
  return (meta.full_name || meta.name || (user.email || "").split("@")[0] || "Fan").trim();
};

export const initial = (user) => (displayName(user) || "?").slice(0, 1).toUpperCase();

// Gravatar via SHA-256 of the email (Gravatar accepts SHA-256 or MD5).
export const gravatarUrl = async (email, size = 80) => {
  const e = (email || "").trim().toLowerCase();
  if (!e || !window.crypto?.subtle) return null;
  const buf = await window.crypto.subtle.digest("SHA-256", new TextEncoder().encode(e));
  const hex = Array.from(new Uint8Array(buf)).map((b) => b.toString(16).padStart(2, "0")).join("");
  return `https://www.gravatar.com/avatar/${hex}?d=404&s=${size}`;
};
